import styled from "styled-components";
import { theme } from "styles/theme";
export const PublishGrid = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 513px;
  & > h2 {
    margin: 0 0 24px 0;
  }
  & > h4 {
    padding-bottom: 16px;
    white-space: pre-wrap;
    word-break: break-word;
  }
  & > div {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 24px;
    justify-content: end;
    width: 100%;
  }

  & ul {
    /* list-style: none; */
    margin-bottom: 8px;

    & li {
      color: ${theme.colors.text};
    }
  }
`;
